// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateGrantRequest
 */
export interface CreateGrantRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGrantRequest
     */
    capability_set: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGrantRequest
     */
    email: string;
}

/**
 * Check if a given object implements the CreateGrantRequest interface.
 */
export function instanceOfCreateGrantRequest(value: object): value is CreateGrantRequest {
    if (!('capability_set' in value) || value['capability_set'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function CreateGrantRequestFromJSON(json: any): CreateGrantRequest {
    return CreateGrantRequestFromJSONTyped(json, false);
}

export function CreateGrantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGrantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'capability_set': json['capability_set'],
        'email': json['email'],
    };
}

export function CreateGrantRequestToJSON(json: any): CreateGrantRequest {
    return CreateGrantRequestToJSONTyped(json, false);
}

export function CreateGrantRequestToJSONTyped(value?: CreateGrantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capability_set': value['capability_set'],
        'email': value['email'],
    };
}
